import Confirm from './Confirm';
import Validate from './Validate';
import Wizard from './Wizard';

export { Validate, Confirm };

export default Wizard;
